import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./login.module.css";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import Config from "../../service/Config";
import { useAllProduct } from "../../components/api-context/commonApiContext";

const Login = ({ className = "" }) => {
  const { mobileNo, setMobileNo } = useAllProduct();
  const navigate = useNavigate();
  const [number, setNumber] = useState("");
  const [step, setStep] = useState(1);
  const [generatedUserName, setGeneratedUserName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorVerification, setErrorVerification] = useState("");
  const [session, setSession] = useState(null);
  const [otp, setOTP] = useState("");
  const [otpSend, setOtpSend] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const { authTokens, setAuthTokens } = useAllProduct();
  const rawAuth = localStorage.getItem("authToken");
  const auth = rawAuth ? JSON.parse(rawAuth) : null;
  const client = new CognitoIdentityProviderClient({ region: "ap-south-1" });
  const location = useLocation();

  useEffect(() => {
    // Only navigate if auth is a valid, non-empty object
    if (
      auth &&
      typeof auth === "object" &&
      Object.keys(auth).length > 0 &&
      auth.AccessToken && // Ensure it’s a real auth token
      location.pathname !== "/content"
    ) {
      console.log("Navigating to /content");
      navigate("/content/kyc");
    } else {
      console.log("Navigation skipped: invalid auth or already on /content");
    }
  }, []);

  useEffect(() => {
    console.log("authTokens", authTokens);

    if (authTokens?.idToken && isTokenValid(authTokens?.idToken)) {
      navigate("/content");
    }
  }, [authTokens]);

  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      console.log("Decoded--->", decoded);

      if (decoded.exp * 1000 > Date.now()) {
        return true;
      } else {
        console.log("Token expired. Fetching new tokens...");
        getNewTokens();
        return true;
      }
    } catch (e) {
      console.error("Invalid token:", e.message);
      return false;
    }
  };

  const getNewTokens = async () => {
    console.log("hello World");

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      }); // Replace 'your-region' with your AWS region
      const params = {
        ClientId: Config.Client_Id, // Your Cognito App Client ID
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authTokens.refreshToken,
        },
      };
      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);
      console.log("refereshRes--->", refreshResponse);

      if (refreshResponse.AuthenticationResult) {
        console.log(
          "AccessToken",
          refreshResponse.AuthenticationResult.AccessToken
        );
        console.log("IdToken", refreshResponse.AuthenticationResult.IdToken);
        console.log("Tokens refreshed successfully!");
        setAuthTokens({
          refreshToken: refreshResponse.AuthenticationResult.RefreshToken,
          idToken: refreshResponse.AuthenticationResult.IdToken,
        });
        localStorage.setItem(
          "authTokens",
          JSON.stringify({
            refreshToken: refreshResponse.AuthenticationResult.RefreshToken,
            idToken: refreshResponse.AuthenticationResult.IdToken,
          })
        );
      } else {
        console.log("Unable to refresh tokens.");
      }
    } catch (error) {
      navigate("/");
      console.error("Error refreshing tokens:", error);
    }
  };

  function isValidIndianPhoneNumber(phone) {
    // Regex pattern for Indian phone numbers
    const indianPhoneRegex = /^\+91[ -]?(?:[6-9]\d{9})$/;

    if (indianPhoneRegex.test(phone)) {
      return true;
    } else {
      setErrorMessage("Please enter a valid phone number");
      return false;
    }
  }

  const cognitoClient = new CognitoIdentityProviderClient({
    region: "ap-south-1",
  });

  const handleLogin = async () => {
    if (
      number[0] != "6" &&
      number[0] != "7" &&
      number[0] != "8" &&
      number[0] != "9"
    ) {
      setErrorMessage("Phone number is a required field");
    }
    if (number === "") {
      setErrorMessage("Phone number is a required field");
      return;
    }
    let loginNumber = `+91${number}`;
    console.log("verify validity");

    if (!isValidIndianPhoneNumber(loginNumber)) {
      console.log("invalid phonenumber");

      return;
    }

    try {
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: Config.Client_Id, // App client ID
        AuthParameters: { USERNAME: loginNumber },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      console.log("Auth Response:", authResponse);

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        // setOtpSent(true);
        setMobileNo(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
        setErrorVerification("");
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This phone number is not registered");
      console.error("Error during sending OTP:", error);
    }
  };

  const HandleOtp = async () => {
    console.log(otp);

    // const otpString = otp.join("");
    // if (otpString == "") {
    //   setErrorVerification("OTP is a required field");
    //   return;
    // }
    // if (otpString.length != 6) {
    //   setErrorVerification("Invalid OTP");
    //   return;
    // }
    let loginNumber = `+91${number}`;
    try {
      const params = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ClientId: Config.Client_Id,
        ChallengeResponses: {
          USERNAME: loginNumber,
          ANSWER: otp,
        },
        Session: session,
      };

      const command = new RespondToAuthChallengeCommand(params);
      const verifyResponse = await cognitoClient.send(command);
      console.log("Verify Response:", verifyResponse);

      if (verifyResponse.AuthenticationResult) {
        setOtpVerified(true);
        let Idtoken = verifyResponse.AuthenticationResult.IdToken;
        const authToken = {
          AccessToken: verifyResponse.AuthenticationResult.AccessToken,
          RefreshToken: verifyResponse.AuthenticationResult.RefreshToken,
          IdToken: verifyResponse.AuthenticationResult.IdToken,
        };
        let token = jwtDecode(Idtoken);
        console.log("token", token);
        const isVerified = token["custom:cupi_onboarding"];
        // const isVerified = token["phone_number_verified"];
        localStorage.setItem("username", token["phone_number"]);
        localStorage.setItem("email", token["email"]);
        console.log("isVerified", isVerified);
        console.log("token test---->", JSON.stringify(authToken));

        if (isVerified) {
          localStorage.setItem("authToken", JSON.stringify(authToken));
          // console.log("User is authorized as:", isVerified ? "Admin" : "Owner");
          // companyStore.setUserType("PineLabUser");
          console.log("OTP verified successfully!");
          navigate("/content/kyc");
        } else {
          console.log("UNAUTHORIZED.");
          setErrorVerification(
            "You are not authorized to access the KYC verification Dashboard."
          );
          // alert("UNAUTHORIZED.");

          return;
        }

        // Check custom:cupi_admin and custom:cupi_owner
        // const isAdmin =
        //   token["custom:cupi_admin"] && token["custom:cupi_admin"] !== "[]";
        // const isOwner =
        //   token["custom:cupi_owner"] && token["custom:cupi_owner"] !== "[]";

        // localStorage.setItem("authToken", JSON.stringify({}));

        // Allow access if either admin or owner role exists
        // if (isAdmin || isOwner) {
        //   localStorage.setItem("authToken", JSON.stringify(authToken));
        //   console.log("User is authorized as:", isAdmin ? "Admin" : "Owner");
        //   // companyStore.setUserType("PineLabUser");
        //   console.log("OTP verified successfully!");
        //   navigate("/selectCompany");
        // } else {
        //   console.log("UNAUTHORIZED.");
        //   setErrorVerification(
        //     "You are not authorized to access the KYC verification Dashboard."
        //   );
        //   // alert("UNAUTHORIZED.");

        //   return;
        // }
      } else {
        setOtpVerified(false);
        setErrorVerification("Invalid OTP. Please try again.");
      }
    } catch (error) {
      resendOtp();
      setErrorVerification("The OTP is invalid. A new one has been sent.");
      console.error("Error during OTP verification:", error);
    }
  };
  const resendOtp = async () => {
    try {
      let loginNumber = `+91${number}`;
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: Config.Client_Id, // App client ID
        AuthParameters: {
          USERNAME: loginNumber,
          PASSWORD: "YourHardcodedPassword", // Hardcoded password for step 1
        },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      console.log("Auth Response:", authResponse);

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        // setOTP(true);
        setMobileNo(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This Phone number is not registered");
      console.error("Error during sending OTP:", error);
    }
  };

  return (
    <div className={[styles.pageContainer, className].join(" ")}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <img
            className={styles.escrowstackLogos27Icon}
            alt=""
            src="/Layer1.svg"
          />
        </div>
        <div className={styles.welcomeToYourEscrowStackParent}>
          <div className={styles.welcomeToYour}>
            Welcome to your Escrow Stack
          </div>
          <div className={styles.pleaseSignInTo}>
            Please sign-in to continue
          </div>
        </div>

        {step === 1 && (
          <div className={styles.inputoutlinedParent}>
            <TextField
              className="input-box"
              autoFocus
              fullWidth
              onChange={(e) => setNumber(e.target.value?.trim())}
              value={number}
              label="Enter your Mobile Number"
              inputProps={{ maxLength: 10 }}
              sx={{
                mb: 5,
                borderRadius: "12px",
              }}
            />

            <div
              className={styles.loadsButtons}
              onClick={() => {
                handleLogin();
              }}
            >
              <img
                className={styles.boxArrowInDownIcon}
                alt=""
                src="/boxarrowindown3.svg"
              />
              <b className={styles.loads}>Get OTP</b>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className={styles.inputoutlinedParent}>
            <TextField
              className="input-box"
              autoFocus
              fullWidth
              inputProps={{ maxLength: 6 }}
              onChange={(e) => setOTP(e.target.value?.trim())}
              value={otp}
              label="Enter OTP"
              sx={{
                // mb: 5,
                borderRadius: "12px",
              }}
            />
            {errorVerification?.length > 0 && (
              <div className={styles.error}>{errorVerification}</div>
            )}
            <div
              className={styles.loadsButtons}
              onClick={() => {
                HandleOtp();
              }}
            >
              <img
                className={styles.boxArrowInDownIcon}
                alt=""
                src="/boxarrowindown3.svg"
              />
              <b className={styles.loads}>VERIFY OTP</b>
            </div>
            <div
              className={styles.loadsButtons}
              onClick={() => {
                resendOtp();
              }}
            >
              <img
                className={styles.boxArrowInDownIcon}
                alt=""
                src="/boxarrowindown3.svg"
              />
              <b className={styles.loads}>RESEND OTP</b>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Login.propTypes = {
  className: PropTypes.string,
};

export default Login;
